<template>
  <div class='positive-indicator'>
    <div>
      <icon v-if="isPositive" name="plus" class='positive-indicator__plus' scale='1'>
      </icon>
      <icon v-else-if="isNegative" name="minus" class='positive-indicator__minus' scale='1'>
      </icon>
      <span :class="{
        'positive-indicator__number': true,
        'positive-indicator__number__positive': isPositive,
        'positive-indicator__number__negative': isNegative,
        }">
        {{message}}
      </span>
    </div>
  </div>
</template>

<script>
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/minus'
import Icon from 'vue-awesome/components/Icon'

export default {
  components: {
    Icon
  },
  props: {
    number: {
      type: Number,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  },
  computed: {
    isPositive () {
      return this.number > 0
    },
    isNegative () {
      return this.number < 0
    }
  }
}
</script>

<style lang='scss'>
.positive-indicator {
  background-color: white;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-flex: 0;
  -ms-flex-positive: 0;
  flex-grow: 0;
  box-sizing: border-box;
  height: 1.875rem;
  border-radius: 0.9375rem;
  border: 0.125rem solid white;
  margin-top: 0.3125rem;
  margin-bottom: 0.3125rem;
  display: inline-block;
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  color: black;

  &__plus {
    position: relative;
    top: 4px;
    color: green;
  }

  &__minus {
    color:red;
    position: relative;
    top: 4px;
  }

  &__number {
    &__positive {
    }

    &__negative {
    }
  }
}
</style>



// WEBPACK FOOTER //
// PositiveityIndicator.vue?4df10a2c